export default __webpack_public_path__ + "static/media/key.d5966924.svg";